import React, { useEffect, useState } from 'react';
import { BasicLoading, Box, SvgIcon } from '@agilize/components-core';
import SendSolicitationButton from '@components/sendSolicitationButton/SendSolicitationButton';
import { useFetch } from '@services/useFetch/useFetch';
import ZendeskChatButton from '@components/zendeskChatButton/ZendeskChatButton';
import { ButtonTitle, StyledFloatingMenuButton } from './HelpButton.styles';

const HelpButton = () => {
  const [actionIsOpen, setActionOpen] = useState(false);
  const handleToggleAction = () => setActionOpen(!actionIsOpen);
  const { doFetch: getLinkZendesk, isFetching } = useFetch('/admin/zendesk/url', 'get', {
    onSuccess: data => {
      window.open(data.url);
    },
  });

  const options = [
    {
      title: <SendSolicitationButton />,
      action: 'send_solicitation',
    },
    {
      title: <ZendeskChatButton />,
      action: 'chat',
    },
  ];

  const onClickOption = option => {
    if (option === 'send_solicitation') {
      return getLinkZendesk();
    }
  };

  return (
    <StyledFloatingMenuButton
      testId="help-button"
      loading={isFetching}
      disabled={isFetching}
      isOpen={actionIsOpen}
      itemWidth={265}
      onCloseAction={handleToggleAction}
      options={options}
      handleOptionClick={onClickOption}
      minWidth={95}
      maxWidth={95}
      maxHeight={40}
      minHeight={40}>
      <SvgIcon fill={actionIsOpen ? 'purple500' : 'grey700'} src={`${process.env.APP_PATH}public/assets/icons/comment-question.svg`} />
      {isFetching ? (
        <Box ml={2}>
          <BasicLoading thickness={2} size={20} />{' '}
        </Box>
      ) : (
        <ButtonTitle width="95px">Ajuda</ButtonTitle>
      )}
    </StyledFloatingMenuButton>
  );
};

export default HelpButton;
